import React, { useState } from 'react';
import { AccountsTab } from './accounts/AccountsTab';
import { UsersTab } from './users/UsersTab';
import { RolesTab } from './roles/RolesTab';

export function AccountsUsersPage() {
    const [activeTab, setActiveTab] = useState('accounts');

    const tabs = [
        { label: 'Cuentas', value: 'accounts', render: () => <AccountsTab /> },
        { label: 'Usuarios', value: 'users', render: () => <UsersTab /> },
        { label: 'Roles', value: 'roles', render: () => <RolesTab /> },
    ];

    const current = tabs.find((tab) => tab.value === activeTab) || tabs[0];

    return (
        <div className="container">
            <nav className="products mb-4">
                <ul>
                    {tabs.map((tab) => (
                        <li
                            key={tab.value}
                            className={activeTab === tab.value ? 'selected' : ''}
                            onClick={() => setActiveTab(tab.value)}
                        >
                            {tab.label}
                        </li>
                    ))}
                </ul>
            </nav>

            {current.render()}
        </div>
    );
}

export default AccountsUsersPage;
